import { useState, useEffect } from 'react';
import { getPostsForSite } from '../../lib/directus';

export interface ArchiveEntry {
  year: number;
  month: number;
  monthName: string;
  count: number;
}

export const useArchive = (domain: string) => {
  const [archive, setArchive] = useState<ArchiveEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArchive = async () => {
      try {
        setLoading(true);
        const posts = await getPostsForSite(domain);
        const map = new Map<string, { year: number; month: number; count: number }>();
        if (Array.isArray(posts)) {
          posts.forEach((post: any) => {
            if (post.publish_date) {
              const date = new Date(post.publish_date);
              const year = date.getFullYear();
              const month = date.getMonth() + 1;
              const key = `${year}-${month}`;
              const existing = map.get(key);
              if (existing) existing.count += 1;
              else map.set(key, { year, month, count: 1 });
            }
          });
        }
        const entries: ArchiveEntry[] = Array.from(map.values())
          .map(({ year, month, count }) => ({
            year,
            month,
            monthName: new Date(year, month - 1).toLocaleDateString('ru-RU', { month: 'long' }),
            count,
          }))
          .sort((a, b) => {
            if (a.year !== b.year) return b.year - a.year;
            return b.month - a.month;
          });
        setArchive(entries);
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки архива:', err);
        setError('Не удалось загрузить архив');
      } finally {
        setLoading(false);
      }
    };
    fetchArchive();
  }, [domain]);

  return { archive, loading, error };
};